import { clock } from '@/services/clock';

export const parseRelativeDateSelection = (
  compareTo: number,
  compareToUnit: string,
  startPoint?: number
) => {
  let today = clock.date();
  if (startPoint) {
    today = new Date(startPoint);
  }
  switch (compareToUnit) {
    case 'd': {
      today.setDate(today.getDate() - compareTo);
      break;
    }
    case 'm': {
      today.setMonth(today.getMonth() - compareTo);
      break;
    }
    case 'y': {
      today.setFullYear(today.getFullYear() - compareTo);
      break;
    }
    case 'mtd': {
      const targetMonth = today.getMonth() - compareTo + 1;
      today.setMonth(targetMonth, 1);
      today.setUTCHours(0, 0, 0, 0);
      break;
    }
    case 'ytd': {
      const targetYear = today.getFullYear() - compareTo + 1;
      today.setFullYear(targetYear, 0, 1);
      today.setUTCHours(0, 0, 0, 0);
      break;
    }
  }
  return today;
};
